/*
 * @Author: Alan
 * @Date: 2023-07-04 12:27:14
 * @LastEditors: Alan
 * @LastEditTime: 2023-09-04 15:55:07
 * @Description: 紧急公告
 * @FilePath: /F1-M2-WEB-Code/components/Announcement/index.js
 */
import React from "react";
import { Button, Modal, Radio, Checkbox } from "antd";

import { CheckOutlined, CloseOutlined } from "@ant-design/icons";

import { get } from "$ACTIONS/TlcRequest";
import { ApiPort } from "$ACTIONS/TLCAPI";
export default class Announcement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isChecked: false,
            value: "1",
            visible: false,
            data: [],
        };
    }

    componentDidMount() {
        this.NewsList();
    }

    NewsList = () => {
        const { playGame, optionType } = this.props;
        // 未登入
        if (!localStorage.getItem("access_token")) {
            typeof playGame === "function" && playGame();
            return;
        }
        // 是否勾選不再显示
        const tag =
            localStorage.getItem(optionType + "_StorageAnnouncement") ||
            sessionStorage.getItem(optionType + "_sessionStorageAnnouncement");
        if (tag) {
            typeof playGame === "function" && playGame();
            return;
        }
        if (optionType) {
            get(ApiPort.getNews + `&optionType=${optionType}`)
                .then((res) => {
                    if (res && res.result && Array.isArray(res.result)) {
                        res.result = res.result.length ? res.result[0] : {}; // just always pick 1st element, same as M1 way
                    }
                    if (
                        res &&
                        res.isSuccess &&
                        JSON.stringify(res.result) != "{}" &&
                        res.result
                    ) {
                        this.setState({
                            data: res.result,
                            visible: true,
                        });
                    } else {
                        typeof playGame === "function" && playGame();
                    }
                })
                .catch((err) => {
                    console.log("GetAnnouncementPopup err", err);
                    typeof playGame === "function" && playGame();
                });
        } else {
            typeof playGame === "function" && playGame();
        }
    };

    onChangeRadio = (value) => {
        Pushgtagpiwikurl('deposit_announcement_popup', 'Deposit Announcement Popup')
		Pushgtagdata('Deposit', 'Do Not Show Popup', 'Deposit_Popup_C_Notshow')
        this.setState({
            isChecked: value.target.checked,
        });
        const { optionType } = this.props;
        if (value.target.checked) {
            localStorage.setItem(optionType + "_StorageAnnouncement", true);
        } else {
            localStorage.removeItem(optionType + "_StorageAnnouncement");
        }
    };

    setsessionStorage = () => {
        const { optionType, ProductPage } = this.props;
        if (ProductPage) {
            sessionStorage.setItem(
                optionType + "_sessionStorageAnnouncement",
                true
            );
        }
    };

    handleCancel = () => {
        const { playGame } = this.props;
        this.setsessionStorage();
        this.setState({ visible: false }, () => {
            typeof playGame === "function" && playGame();
        });
    };
    render() {
        const { isChecked, value, data, visible } = this.state;

        return (
            <React.Fragment>
                <Modal
                    title="แจ้งเตือน" //重要公告
                    centered={true}
                    visible={visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={null}
                    width={400}
                    maskClosable={false}
                    className="announcement-modal"
                >
                    <div>
                        <center className="title">
                            <h3>{data && data.topic}</h3>
                        </center>
                        <div
                            className="content"
                            dangerouslySetInnerHTML={{
                                __html: data && data.content,
                            }}
                        />
                        <br />
                        <div className="footer">
                            <div className="checkbox-button-container">
                                <Checkbox
                                    checked={isChecked}
                                    onChange={this.onChangeRadio}
                                >
                                    ไม่ต้องแสดงข้อความนี้อีก
                                    {/* 不再显示 */}
                                </Checkbox>
                            </div>
                            <br />
                            <Button
                                size="large"
                                className="customer-service"
                                block
                                type="primary"
                                onClick={() => {
                                    global.PopUpLiveChat()
                                    Pushgtagpiwikurl('deposit_announcement_popup', 'Deposit Announcement Popup')
                                    Pushgtagdata('Deposit', 'Contact CS', 'Deposit_Popup_C_CS')
                                }}
                            >
                                <img src="/th/img/home/CS.svg" alt="CS" />
                                ติดต่อฝ่ายบริการลูกค้า
                                {/* 联系在线客服 */}
                            </Button>
                        </div>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}
